module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('banner'), _vm._v(" "), _c('home-body-pc', {
    staticClass: "pc-show"
  }, [_c('Choose-package', {
    attrs: {
      "all-packages": _vm.allPackages
    }
  })], 1), _vm._v(" "), _c('BannerPopup'), _vm._v(" "), _c('home-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-377420f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/Index.vue
// module id = 1299
// module chunks = 1